module.exports = __webpack_public_path__ + "static/poster1-334af08ad3a064c2ea02ac1c45cfeb83.png";